export default {
    namespaced: true, 
    state: {
       editingEnabled: false,
       addingEnabled: false,
       achivement: 0
    },
    mutations: {
    },
    actions: {
    }
  
  }